var Index = Barba.BaseView.extend({
    namespace: 'content',
    onEnter: function() {

    },
    onEnterCompleted: function() {
        // The Transition has just finished.


    },
    onLeave: function() {
        $('html, body').animate({
            scrollTop: 0
        }, 10);
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
